import LeaderLine from 'leader-line-new'
import { defineNuxtPlugin } from 'nuxt/app'

export default defineNuxtPlugin((app) => {
  app.provide('leaderLine', LeaderLine)
})
